export default __webpack_public_path__ + "static/media/Q4_3_resized.d6d52c4a.jpg";